<script>
    import {createEventDispatcher} from "svelte";
    const dispatch = createEventDispatcher();

    export let label = '';
    export let type = 'primary'; // secondary
    export let disabled = false;
    export let running = false;
    export let icon = ''; // 'bag'

    function clickHandler () {
        if (!disabled) {
            dispatch('clicked', {});
        }
    }

</script>

<style>
    button {

        border: none;
        border-radius: 0.75rem;
        font-size: var(--fs-110);
        font-family: inherit;
        font-weight: 400;
        color: var(--price-item-font-color);
        background: var(--price-item-bg-color);
        transition: background-color .2s ease-in-out;

        padding: 1rem 1.25rem;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5em;
    }
    .button--primary {
        background: var(--button-primary-bg-color);
        color: var(--button-primary-text-color);
        border: none;
    }
    .button--secondary {
        padding: 0.8rem 1.5rem;
        font-size: var(--fs-100);
        font-weight: 400;
        color: var(--button-secondary-text-color);
        border: var(--button-secondary-border);
        background: var(--button-secondary-bg-color);
    }
    .button--disabled {
        background: var(--button-disabled-bg-color);
        color: var(--button-disabled-text-color);
    }
    button svg {
        line-height: 1;
        display: inline-block;
        font-size: 120%;
    }
</style>

<button class="button--{ type } {disabled ? 'button--disabled' : 'pointer'}" on:click={clickHandler}>

    {#if (icon === 'bag' && !running)}
        <svg width="1em" height="1em" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.7314 4.85509H14.9727C14.9727 3.65884 14.4975 2.51158 13.6516 1.6657C12.8057 0.819815 11.6584 0.344604 10.4622 0.344604C9.26592 0.344604 8.11866 0.819815 7.27278 1.6657C6.4269 2.51158 5.95169 3.65884 5.95169 4.85509H2.19295C1.7942 4.85509 1.41178 5.0135 1.12982 5.29546C0.847857 5.57742 0.689453 5.95984 0.689453 6.35859V17.6348C0.689453 18.0336 0.847857 18.416 1.12982 18.6979C1.41178 18.9799 1.7942 19.1383 2.19295 19.1383H18.7314C19.1302 19.1383 19.5126 18.9799 19.7945 18.6979C20.0765 18.416 20.2349 18.0336 20.2349 17.6348V6.35859C20.2349 5.95984 20.0765 5.57742 19.7945 5.29546C19.5126 5.0135 19.1302 4.85509 18.7314 4.85509ZM10.4622 1.8481C11.2597 1.8481 12.0245 2.16491 12.5884 2.72883C13.1524 3.29275 13.4692 4.05759 13.4692 4.85509H7.45519C7.45519 4.05759 7.77199 3.29275 8.33591 2.72883C8.89983 2.16491 9.66467 1.8481 10.4622 1.8481ZM18.7314 17.6348H2.19295V6.35859H5.95169V7.86209C5.95169 8.06146 6.03089 8.25267 6.17187 8.39365C6.31285 8.53463 6.50406 8.61383 6.70344 8.61383C6.90281 8.61383 7.09402 8.53463 7.235 8.39365C7.37598 8.25267 7.45519 8.06146 7.45519 7.86209V6.35859H13.4692V7.86209C13.4692 8.06146 13.5484 8.25267 13.6894 8.39365C13.8303 8.53463 14.0215 8.61383 14.2209 8.61383C14.4203 8.61383 14.6115 8.53463 14.7525 8.39365C14.8935 8.25267 14.9727 8.06146 14.9727 7.86209V6.35859H18.7314V17.6348Z" fill="currentColor"/>
        </svg>
    {/if}

    {#if (running)}
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             width="1em" height="1em" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
            <path fill="currentColor" d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
            <animateTransform attributeType="xml"
                      attributeName="transform"
                      type="rotate"
                      from="0 25 25"
                      to="360 25 25"
                      dur="1s"
                      repeatCount="indefinite"/>
            </path>
        </svg>
    {/if}

    { label }
</button>
